import React from 'react'

const GlobalCsrfTokenStateContext = React.createContext(undefined) // Context before fetching csrf token

export default GlobalCsrfTokenStateContext
